'use strict';

exports.__esModule = true;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; // Low-level types that make up operations

var _SerializerValidation = require('./SerializerValidation');

var _SerializerValidation2 = _interopRequireDefault(_SerializerValidation);

var _FastParser = require('./FastParser');

var _FastParser2 = _interopRequireDefault(_FastParser);

var _ChainTypes = require('../../chain/src/ChainTypes');

var _ChainTypes2 = _interopRequireDefault(_ChainTypes);

var _ObjectId = require('../../chain/src/ObjectId');

var _ObjectId2 = _interopRequireDefault(_ObjectId);

var _ecc = require('../../ecc');

var _cjs = require('../../ws/cjs');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Types = {};

var HEX_DUMP = process.env.npm_config__graphene_serializer_hex_dump;

Types.uint8 = {
    fromByteBuffer: function fromByteBuffer(byteBuffer) {
        return byteBuffer.readUint8();
    },
    appendByteBuffer: function appendByteBuffer(byteBuffer, object) {
        _SerializerValidation2.default.require_range(0, 0xFF, object, 'uint8 ' + object);
        byteBuffer.writeUint8(object);
    },
    fromObject: function fromObject(object) {
        _SerializerValidation2.default.require_range(0, 0xFF, object, 'uint8 ' + object);
        return object;
    },
    toObject: function toObject(object) {
        var debug = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        if (debug.use_default && object === undefined) {
            return 0;
        }
        _SerializerValidation2.default.require_range(0, 0xFF, object, 'uint8 ' + object);
        return parseInt(object);
    }
};

var MIN_SIGNED_8 = -1 * Math.pow(2, 7);
var MAX_SIGNED_8 = Math.pow(2, 7) - 1;

Types.int8 = {
    fromByteBuffer: function fromByteBuffer(byteBuffer) {
        return byteBuffer.readInt8();
    },
    appendByteBuffer: function appendByteBuffer(byteBuffer, object) {
        _SerializerValidation2.default.require_range(0, 0xFF, object, 'int8 ' + object);
        byteBuffer.writeInt8(object);
    },
    fromObject: function fromObject(object) {
        _SerializerValidation2.default.require_range(0, 0xFF, object, 'int8 ' + object);
        return object;
    },
    toObject: function toObject(object) {
        var debug = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        if (debug.use_default && object === undefined) {
            return 0;
        }
        _SerializerValidation2.default.require_range(MIN_SIGNED_8, MAX_SIGNED_8, object, 'uint32 ' + object);
        return parseInt(object);
    }
};

Types.uint16 = {
    fromByteBuffer: function fromByteBuffer(byteBuffer) {
        return byteBuffer.readUint16();
    },
    appendByteBuffer: function appendByteBuffer(byteBuffer, object) {
        _SerializerValidation2.default.require_range(0, 0xFFFF, object, 'uint16 ' + object);
        byteBuffer.writeUint16(object);
    },
    fromObject: function fromObject(object) {
        _SerializerValidation2.default.require_range(0, 0xFFFF, object, 'uint16 ' + object);
        return object;
    },
    toObject: function toObject(object) {
        var debug = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        if (debug.use_default && object === undefined) {
            return 0;
        }
        _SerializerValidation2.default.require_range(0, 0xFFFF, object, 'uint16 ' + object);
        return parseInt(object);
    }
};

Types.uint32 = {
    fromByteBuffer: function fromByteBuffer(byteBuffer) {
        return byteBuffer.readUint32();
    },
    appendByteBuffer: function appendByteBuffer(byteBuffer, object) {
        _SerializerValidation2.default.require_range(0, 0xFFFFFFFF, object, 'uint32 ' + object);
        byteBuffer.writeUint32(object);
    },
    fromObject: function fromObject(object) {
        _SerializerValidation2.default.require_range(0, 0xFFFFFFFF, object, 'uint32 ' + object);
        return object;
    },
    toObject: function toObject(object) {
        var debug = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        if (debug.use_default && object === undefined) {
            return 0;
        }
        _SerializerValidation2.default.require_range(0, 0xFFFFFFFF, object, 'uint32 ' + object);
        return parseInt(object);
    }
};

var MIN_SIGNED_32 = -1 * Math.pow(2, 31);
var MAX_SIGNED_32 = Math.pow(2, 31) - 1;

Types.varint32 = {
    fromByteBuffer: function fromByteBuffer(byteBuffer) {
        return byteBuffer.readVarint32();
    },
    appendByteBuffer: function appendByteBuffer(byteBuffer, object) {
        _SerializerValidation2.default.require_range(MIN_SIGNED_32, MAX_SIGNED_32, object, 'uint32 ' + object);
        byteBuffer.writeVarint32(object);
    },
    fromObject: function fromObject(object) {
        _SerializerValidation2.default.require_range(MIN_SIGNED_32, MAX_SIGNED_32, object, 'uint32 ' + object);
        return object;
    },
    toObject: function toObject(object) {
        var debug = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        if (debug.use_default && object === undefined) {
            return 0;
        }
        _SerializerValidation2.default.require_range(MIN_SIGNED_32, MAX_SIGNED_32, object, 'uint32 ' + object);
        return parseInt(object);
    }
};

Types.int64 = {
    fromByteBuffer: function fromByteBuffer(byteBuffer) {
        return byteBuffer.readInt64();
    },
    appendByteBuffer: function appendByteBuffer(byteBuffer, object) {
        _SerializerValidation2.default.required(object);
        byteBuffer.writeInt64(_SerializerValidation2.default.to_long(object));
    },
    fromObject: function fromObject(object) {
        _SerializerValidation2.default.required(object);
        return _SerializerValidation2.default.to_long(object);
    },
    toObject: function toObject(object) {
        var debug = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        if (debug.use_default && object === undefined) {
            return "0";
        }
        _SerializerValidation2.default.required(object);
        return _SerializerValidation2.default.to_long(object).toString();
    }
};

Types.uint64 = {
    fromByteBuffer: function fromByteBuffer(byteBuffer) {
        return byteBuffer.readUint64();
    },
    appendByteBuffer: function appendByteBuffer(byteBuffer, object) {
        byteBuffer.writeUint64(_SerializerValidation2.default.to_long(_SerializerValidation2.default.unsigned(object)));
    },
    fromObject: function fromObject(object) {
        return _SerializerValidation2.default.to_long(_SerializerValidation2.default.unsigned(object));
    },
    toObject: function toObject(object) {
        var debug = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        if (debug.use_default && object === undefined) {
            return "0";
        }
        return _SerializerValidation2.default.to_long(object).toString();
    }
};

Types.string = {
    fromByteBuffer: function fromByteBuffer(byteBuffer) {
        var b_copy = void 0;
        var len = byteBuffer.readVarint32();
        b_copy = byteBuffer.copy(byteBuffer.offset, byteBuffer.offset + len);
        byteBuffer.skip(len);
        return Buffer.from(b_copy.toBinary(), 'binary');
    },
    appendByteBuffer: function appendByteBuffer(byteBuffer, object) {
        _SerializerValidation2.default.required(object);
        byteBuffer.writeVarint32(object.length);
        byteBuffer.append(object.toString('binary'), 'binary');
    },
    fromObject: function fromObject(object) {
        _SerializerValidation2.default.required(object);
        return Buffer.from(object);
    },
    toObject: function toObject(object) {
        var debug = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        if (debug.use_default && object === undefined) {
            return "";
        }
        return object.toString();
    }
};

Types.bytes = function (size) {
    return {
        fromByteBuffer: function fromByteBuffer(byteBuffer) {
            if (size === undefined) {
                var _b_copy = void 0;
                var len = byteBuffer.readVarint32();
                _b_copy = byteBuffer.copy(byteBuffer.offset, byteBuffer.offset + len);
                byteBuffer.skip(len);
                return Buffer.from(_b_copy.toBinary(), 'binary');
            } else {
                b_copy = byteBuffer.copy(byteBuffer.offset, byteBuffer.offset + size);
                byteBuffer.skip(size);
                return Buffer.from(b_copy.toBinary(), 'binary');
            }
        },
        appendByteBuffer: function appendByteBuffer(byteBuffer, object) {
            _SerializerValidation2.default.required(object);
            if (typeof object === "string") {
                object = Buffer.from(object, "hex");
            }
            if (size === undefined) {
                byteBuffer.writeVarint32(object.length);
            }
            byteBuffer.append(object.toString('binary'), 'binary');
        },
        fromObject: function fromObject(object) {
            _SerializerValidation2.default.required(object);
            if (Buffer.isBuffer(object)) {
                return object;
            }
            return Buffer.from(object, 'hex');
        },
        toObject: function toObject(object) {
            var debug = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

            if (debug.use_default && object === undefined) {
                var zeros = function zeros(num) {
                    return new Array(num).join("00");
                };
                return zeros(size);
            }
            _SerializerValidation2.default.required(object);
            return object.toString('hex');
        }
    };
};

Types.bool = {
    fromByteBuffer: function fromByteBuffer(byteBuffer) {
        return byteBuffer.readUint8() === 1;
    },
    appendByteBuffer: function appendByteBuffer(byteBuffer, object) {
        // supports boolean or integer
        byteBuffer.writeUint8(JSON.parse(object) ? 1 : 0);
    },
    fromObject: function fromObject(object) {
        return !!JSON.parse(object);
    },
    toObject: function toObject(object) {
        var debug = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        if (debug.use_default && object === undefined) {
            return false;
        }
        return !!JSON.parse(object);
    }
};

Types.void = {
    fromByteBuffer: function fromByteBuffer(byteBuffer) {
        throw new Error("(void) undefined type");
    },
    appendByteBuffer: function appendByteBuffer(byteBuffer, object) {
        throw new Error("(void) undefined type");
    },
    fromObject: function fromObject(object) {
        throw new Error("(void) undefined type");
    },
    toObject: function toObject(object) {
        var debug = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        if (debug.use_default && object === undefined) {
            return undefined;
        }
        throw new Error("(void) undefined type");
    }
};

Types.array = function (st_operation) {
    return {
        fromByteBuffer: function fromByteBuffer(byteBuffer) {
            var size = byteBuffer.readVarint32();
            if (HEX_DUMP && process.env.ENVIRONMENT === 'DEV') {
                console.log("varint32 size = " + size.toString(16));
            }
            var result = [];
            for (var i = 0; 0 < size ? i < size : i > size; 0 < size ? i++ : i++) {
                result.push(st_operation.fromByteBuffer(byteBuffer));
            }
            return sortOperation(result, st_operation);
        },
        appendByteBuffer: function appendByteBuffer(byteBuffer, object) {
            _SerializerValidation2.default.required(object);
            object = sortOperation(object, st_operation);
            byteBuffer.writeVarint32(object.length);
            for (var i = 0, o; i < object.length; i++) {
                o = object[i];
                st_operation.appendByteBuffer(byteBuffer, o);
            }
        },
        fromObject: function fromObject(object) {
            _SerializerValidation2.default.required(object);
            object = sortOperation(object, st_operation);
            var result = [];
            for (var i = 0, o; i < object.length; i++) {
                o = object[i];
                result.push(st_operation.fromObject(o));
            }
            return result;
        },
        toObject: function toObject(object) {
            var debug = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

            if (debug.use_default && object === undefined) {
                return [st_operation.toObject(object, debug)];
            }
            _SerializerValidation2.default.required(object);
            object = sortOperation(object, st_operation);

            var result = [];
            for (var i = 0, o; i < object.length; i++) {
                o = object[i];
                result.push(st_operation.toObject(o, debug));
            }
            return result;
        }
    };
};

Types.time_point_sec = {
    fromByteBuffer: function fromByteBuffer(byteBuffer) {
        return byteBuffer.readUint32();
    },
    appendByteBuffer: function appendByteBuffer(byteBuffer, object) {
        if (typeof object !== "number") {
            object = Types.time_point_sec.fromObject(object);
        }
        byteBuffer.writeUint32(object);
    },
    fromObject: function fromObject(object) {
        _SerializerValidation2.default.required(object);

        if (typeof object === "number") {
            return object;
        }

        if (object.getTime) {
            return Math.floor(object.getTime() / 1000);
        }

        if (typeof object !== "string") {
            throw new Error("Unknown date type: " + object);
        }

        // if(typeof object === "string" && !/Z$/.test(object))
        //     object = object + "Z"

        return Math.floor(new Date(object).getTime() / 1000);
    },
    toObject: function toObject(object) {
        var debug = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        if (debug.use_default && object === undefined) {
            return new Date(0).toISOString().split('.')[0];
        }
        _SerializerValidation2.default.required(object);

        if (typeof object === "string") {
            return object;
        }

        if (object.getTime) {
            return object.toISOString().split('.')[0];
        }

        var int = parseInt(object);
        _SerializerValidation2.default.require_range(0, 0xFFFFFFFF, int, 'uint32 ' + object);
        return new Date(int * 1000).toISOString().split('.')[0];
    }
};

Types.set = function (st_operation) {
    return {
        validate: function validate(array) {
            var dup_map = {};
            for (var i = 0, o; i < array.length; i++) {
                o = array[i];
                var ref = void 0;
                if (ref = typeof o === 'undefined' ? 'undefined' : _typeof(o), ['string', 'number'].indexOf(ref) >= 0) {
                    if (dup_map[o] !== undefined) {
                        throw new Error("duplicate (set)");
                    }
                    dup_map[o] = true;
                }
            }
            return sortOperation(array, st_operation);
        },
        fromByteBuffer: function fromByteBuffer(byteBuffer) {
            var size = byteBuffer.readVarint32();
            if (HEX_DUMP && process.env.ENVIRONMENT === 'DEV') {
                console.log("varint32 size = " + size.toString(16));
            }
            return this.validate(function () {
                var result = [];
                for (var i = 0; 0 < size ? i < size : i > size; 0 < size ? i++ : i++) {
                    result.push(st_operation.fromByteBuffer(byteBuffer));
                }
                return result;
            }());
        },
        appendByteBuffer: function appendByteBuffer(byteBuffer, object) {
            if (!object) {
                object = [];
            }
            byteBuffer.writeVarint32(object.length);
            var iterable = this.validate(object);
            for (var i = 0, o; i < iterable.length; i++) {
                o = iterable[i];
                st_operation.appendByteBuffer(byteBuffer, o);
            }
        },
        fromObject: function fromObject(object) {
            if (!object) {
                object = [];
            }
            return this.validate(function () {
                var result = [];
                for (var i = 0, o; i < object.length; i++) {
                    o = object[i];
                    result.push(st_operation.fromObject(o));
                }
                return result;
            }());
        },
        toObject: function toObject(object) {
            var debug = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

            if (debug.use_default && object === undefined) {
                return [st_operation.toObject(object, debug)];
            }
            if (!object) {
                object = [];
            }
            return this.validate(function () {
                var result = [];
                for (var i = 0, o; i < object.length; i++) {
                    o = object[i];
                    result.push(st_operation.toObject(o, debug));
                }
                return result;
            }());
        }
    };
};

// global_parameters_update_operation current_fees
Types.fixed_array = function (count, st_operation) {
    return {
        fromByteBuffer: function fromByteBuffer(byteBuffer) {
            var i = void 0,
                j = void 0,
                ref = void 0,
                results = void 0;
            results = [];
            for (i = j = 0, ref = count; j < ref; i = j += 1) {
                results.push(st_operation.fromByteBuffer(byteBuffer));
            }
            return sortOperation(results, st_operation);
        },
        appendByteBuffer: function appendByteBuffer(byteBuffer, object) {
            var i = void 0,
                j = void 0,
                ref = void 0;
            if (count !== 0) {
                _SerializerValidation2.default.required(object);
                object = sortOperation(object, st_operation);
            }
            for (i = j = 0, ref = count; j < ref; i = j += 1) {
                st_operation.appendByteBuffer(byteBuffer, object[i]);
            }
        },
        fromObject: function fromObject(object) {
            var i = void 0,
                j = void 0,
                ref = void 0,
                results = void 0;
            if (count !== 0) {
                _SerializerValidation2.default.required(object);
            }
            results = [];
            for (i = j = 0, ref = count; j < ref; i = j += 1) {
                results.push(st_operation.fromObject(object[i]));
            }
            return results;
        },
        toObject: function toObject(object, debug) {
            var i = void 0,
                j = void 0,
                k = void 0,
                ref = void 0,
                ref1 = void 0,
                results = void 0,
                results1 = void 0;
            if (debug == null) {
                debug = {};
            }
            if (debug.use_default && object === void 0) {
                results = [];
                for (i = j = 0, ref = count; j < ref; i = j += 1) {
                    results.push(st_operation.toObject(void 0, debug));
                }
                return results;
            }
            if (count !== 0) {
                _SerializerValidation2.default.required(object);
            }
            results1 = [];
            for (i = k = 0, ref1 = count; k < ref1; i = k += 1) {
                results1.push(st_operation.toObject(object[i], debug));
            }
            return results1;
        }
    };
};

/* Supports instance numbers (11) or object types (1.2.11).  Object type
Validation is enforced when an object type is used. */
var id_type = function id_type(reserved_spaces, object_type) {
    _SerializerValidation2.default.required(reserved_spaces, "reserved_spaces");
    _SerializerValidation2.default.required(object_type, "object_type");
    return {
        fromByteBuffer: function fromByteBuffer(byteBuffer) {
            return byteBuffer.readVarint32();
        },
        appendByteBuffer: function appendByteBuffer(byteBuffer, object) {
            _SerializerValidation2.default.required(object);
            if (object.resolve !== undefined) {
                object = object.resolve;
            }
            try {
                // convert 1.2.n into just n
                if (/^[0-9]+\.[0-9]+\.[0-9]+$/.test(object)) {
                    object = _SerializerValidation2.default.get_instance(reserved_spaces, object_type, object);
                }
                byteBuffer.writeVarint32(_SerializerValidation2.default.to_number(object));
            } catch (exception) {
                throw new Error(exception);
            }
        },
        fromObject: function fromObject(object) {
            _SerializerValidation2.default.required(object);
            if (object.resolve !== undefined) {
                object = object.resolve;
            }
            try {
                if (_SerializerValidation2.default.is_digits(object)) {
                    return _SerializerValidation2.default.to_number(object);
                }
                return _SerializerValidation2.default.get_instance(reserved_spaces, object_type, object);
            } catch (exception) {
                throw new Error(exception);
            }
        },
        toObject: function toObject(object) {
            var debug = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

            var object_type_id = void 0;
            if (reserved_spaces === 1) {
                object_type_id = _ChainTypes2.default.object_type[object_type];
            } else if (reserved_spaces === 2) {
                object_type_id = _ChainTypes2.default.impl_object_type[object_type];
            }
            if (debug.use_default && object === undefined) {
                return reserved_spaces + '.' + object_type_id + '.0';
            }
            _SerializerValidation2.default.required(object);
            if (object.resolve !== undefined) {
                object = object.resolve;
            }
            try {
                if (/^[0-9]+\.[0-9]+\.[0-9]+$/.test(object)) {
                    object = _SerializerValidation2.default.get_instance(reserved_spaces, object_type, object);
                }
                return reserved_spaces + '.' + object_type_id + '.' + object;
            } catch (exception) {
                throw new Error(exception);
            }
        }
    };
};

Types.protocol_id_type = function (name) {
    _SerializerValidation2.default.required(name, "name");
    return id_type(_ChainTypes2.default.reserved_spaces.protocol_ids, name);
};

Types.implementation_id_type = function (name) {
    _SerializerValidation2.default.required(name, "name");
    return id_type(_ChainTypes2.default.reserved_spaces.implementation_ids, name);
};

Types.object_id_type = {
    fromByteBuffer: function fromByteBuffer(b) {
        return _ObjectId2.default.fromByteBuffer(b);
    },
    appendByteBuffer: function appendByteBuffer(b, object) {
        _SerializerValidation2.default.required(object);
        if (object.resolve !== undefined) {
            object = object.resolve;
        }
        object = _ObjectId2.default.fromString(object);
        object.appendByteBuffer(b);
    },
    fromObject: function fromObject(object) {
        _SerializerValidation2.default.required(object);
        if (object.resolve !== undefined) {
            object = object.resolve;
        }
        return _ObjectId2.default.fromString(object);
    },
    toObject: function toObject(object) {
        var debug = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        if (debug.use_default && object === undefined) {
            return "0.0.0";
        }
        _SerializerValidation2.default.required(object);
        if (object.resolve !== undefined) {
            object = object.resolve;
        }
        object = _ObjectId2.default.fromString(object);
        return object.toString();
    }
};

Types.vote_id = {
    TYPE: 0x000000FF,
    ID: 0xFFFFFF00,
    fromByteBuffer: function fromByteBuffer(byteBuffer) {
        var value = byteBuffer.readUint32();
        return {
            type: value & this.TYPE,
            id: value & this.ID
        };
    },
    appendByteBuffer: function appendByteBuffer(byteBuffer, object) {
        _SerializerValidation2.default.required(object);
        if (object === "string") {
            object = Types.vote_id.fromObject(object);
        }
        var value = object.id << 8 | object.type;
        byteBuffer.writeUint32(value);
    },
    fromObject: function fromObject(object) {
        _SerializerValidation2.default.required(object, "(type vote_id)");
        if ((typeof object === 'undefined' ? 'undefined' : _typeof(object)) === "object") {
            _SerializerValidation2.default.required(object.type, "type");
            _SerializerValidation2.default.required(object.id, "id");
            return object;
        }
        _SerializerValidation2.default.require_test(/^[0-9]+:[0-9]+$/, object, 'vote_id format ' + object);

        var _object$split = object.split(':'),
            type = _object$split[0],
            id = _object$split[1];

        _SerializerValidation2.default.require_range(0, 0xff, type, 'vote type ' + object);
        _SerializerValidation2.default.require_range(0, 0xffffff, id, 'vote id ' + object);
        return { type: type, id: id };
    },
    toObject: function toObject(object) {
        var debug = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        if (debug.use_default && object === undefined) {
            return "0:0";
        }
        _SerializerValidation2.default.required(object);
        if (typeof object === "string") {
            object = Types.vote_id.fromObject(object);
        }
        return object.type + ":" + object.id;
    },
    compare: function compare(a, b) {
        if ((typeof a === 'undefined' ? 'undefined' : _typeof(a)) !== "object") {
            a = Types.vote_id.fromObject(a);
        }
        if ((typeof b === 'undefined' ? 'undefined' : _typeof(b)) !== "object") {
            b = Types.vote_id.fromObject(b);
        }
        return parseInt(a.id) - parseInt(b.id);
    }
};

Types.optional = function (st_operation) {
    _SerializerValidation2.default.required(st_operation, "st_operation");
    return {
        fromByteBuffer: function fromByteBuffer(byteBuffer) {
            if (!(byteBuffer.readUint8() === 1)) {
                return undefined;
            }
            return st_operation.fromByteBuffer(byteBuffer);
        },
        appendByteBuffer: function appendByteBuffer(byteBuffer, object) {
            if (object !== null && object !== undefined) {
                byteBuffer.writeUint8(1);
                st_operation.appendByteBuffer(byteBuffer, object);
            } else {
                byteBuffer.writeUint8(0);
            }
        },
        fromObject: function fromObject(object) {
            if (object === undefined) {
                return undefined;
            }
            return st_operation.fromObject(object);
        },
        toObject: function toObject(object) {
            var debug = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

            // toObject is only null save if use_default is true
            var result_object = function () {
                if (!debug.use_default && object === undefined) {
                    return undefined;
                } else {
                    return st_operation.toObject(object, debug);
                }
            }();

            if (debug.annotate) {
                if ((typeof result_object === 'undefined' ? 'undefined' : _typeof(result_object)) === "object") {
                    result_object.__optional = "parent is optional";
                } else {
                    result_object = { __optional: result_object };
                }
            }
            return result_object;
        }
    };
};

Types.static_variant = function (_st_operations) {
    return {
        nosort: true,
        st_operations: _st_operations,
        fromByteBuffer: function fromByteBuffer(byteBuffer) {
            var type_id = byteBuffer.readVarint32();
            var st_operation = this.st_operations[type_id];
            if (HEX_DUMP) {
                console.error('static_variant id 0x' + type_id.toString(16) + ' (' + type_id + ')');
            }
            _SerializerValidation2.default.required(st_operation, 'operation ' + type_id);
            return [type_id, st_operation.fromByteBuffer(byteBuffer)];
        },
        appendByteBuffer: function appendByteBuffer(byteBuffer, object) {
            _SerializerValidation2.default.required(object);
            var type_id = object[0];
            var st_operation = this.st_operations[type_id];
            _SerializerValidation2.default.required(st_operation, 'operation ' + type_id);
            byteBuffer.writeVarint32(type_id);
            st_operation.appendByteBuffer(byteBuffer, object[1]);
        },
        fromObject: function fromObject(object) {
            _SerializerValidation2.default.required(object);
            var type_id = object[0];
            var st_operation = this.st_operations[type_id];
            _SerializerValidation2.default.required(st_operation, 'operation ' + type_id);
            return [type_id, st_operation.fromObject(object[1])];
        },
        toObject: function toObject(object) {
            var debug = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

            if (debug.use_default && object === undefined) {
                return [0, this.st_operations[0].toObject(undefined, debug)];
            }
            _SerializerValidation2.default.required(object);
            var type_id = object[0];
            var st_operation = this.st_operations[type_id];
            _SerializerValidation2.default.required(st_operation, 'operation ' + type_id);
            return [type_id, st_operation.toObject(object[1], debug)];
        }
    };
};

Types.map = function (key_st_operation, value_st_operation) {
    return {
        validate: function validate(array) {
            if (!Array.isArray(array)) {
                throw new Error("expecting array");
            }
            var dup_map = {};
            for (var i = 0, o; i < array.length; i++) {
                o = array[i];
                var ref = void 0;
                if (!(o.length === 2)) {
                    throw new Error("expecting two elements");
                }
                if (ref = _typeof(o[0]), ['number', 'string'].indexOf(ref) >= 0) {
                    if (dup_map[o[0]] !== undefined) {
                        throw new Error("duplicate (map)");
                    }
                    dup_map[o[0]] = true;
                }
            }
            return sortOperation(array, key_st_operation);
        },
        fromByteBuffer: function fromByteBuffer(byteBuffer) {
            var result = [];
            var end = byteBuffer.readVarint32();
            for (var i = 0; 0 < end ? i < end : i > end; 0 < end ? i++ : i++) {
                result.push([key_st_operation.fromByteBuffer(byteBuffer), value_st_operation.fromByteBuffer(byteBuffer)]);
            }
            return this.validate(result);
        },
        appendByteBuffer: function appendByteBuffer(byteBuffer, object) {
            this.validate(object);
            byteBuffer.writeVarint32(object.length);
            for (var i = 0, o; i < object.length; i++) {
                o = object[i];
                key_st_operation.appendByteBuffer(byteBuffer, o[0]);
                value_st_operation.appendByteBuffer(byteBuffer, o[1]);
            }
        },
        fromObject: function fromObject(object) {
            _SerializerValidation2.default.required(object);
            var result = [];
            for (var i = 0, o; i < object.length; i++) {
                o = object[i];
                result.push([key_st_operation.fromObject(o[0]), value_st_operation.fromObject(o[1])]);
            }
            return this.validate(result);
        },
        toObject: function toObject(object) {
            var debug = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

            if (debug.use_default && object === undefined) {
                return [[key_st_operation.toObject(undefined, debug), value_st_operation.toObject(undefined, debug)]];
            }
            _SerializerValidation2.default.required(object);
            object = this.validate(object);
            var result = [];
            for (var i = 0, o; i < object.length; i++) {
                o = object[i];
                result.push([key_st_operation.toObject(o[0], debug), value_st_operation.toObject(o[1], debug)]);
            }
            return result;
        }
    };
};

Types.public_key = {
    toPublic: function toPublic(object) {
        if (object.resolve !== undefined) {
            object = object.resolve;
        }
        return object == null ? object : object.Q ? object : _ecc.PublicKey.fromStringOrThrow(object);
    },
    fromByteBuffer: function fromByteBuffer(byteBuffer) {
        return _FastParser2.default.public_key(byteBuffer);
    },
    appendByteBuffer: function appendByteBuffer(byteBuffer, object) {
        _SerializerValidation2.default.required(object);
        _FastParser2.default.public_key(byteBuffer, Types.public_key.toPublic(object));
    },
    fromObject: function fromObject(object) {
        _SerializerValidation2.default.required(object);
        if (object.Q) {
            return object;
        }
        return Types.public_key.toPublic(object);
    },
    toObject: function toObject(object) {
        var debug = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        if (debug.use_default && object === undefined) {
            return _cjs.ChainConfig.address_prefix + "859gxfnXyUriMgUeThh1fWv3oqcpLFyHa3TfFYC4PK2HqhToVM";
        }
        _SerializerValidation2.default.required(object);
        return object.toString();
    },
    compare: function compare(a, b) {
        return strCmp(a.toAddressString(), b.toAddressString());
    }
};

Types.address = {
    _to_address: function _to_address(object) {
        _SerializerValidation2.default.required(object);
        if (object.addy) {
            return object;
        }
        return _ecc.Address.fromString(object);
    },
    fromByteBuffer: function fromByteBuffer(byteBuffer) {
        return new _ecc.Address(_FastParser2.default.ripemd160(byteBuffer));
    },
    appendByteBuffer: function appendByteBuffer(byteBuffer, object) {
        _FastParser2.default.ripemd160(byteBuffer, Types.address._to_address(object).toBuffer());
    },
    fromObject: function fromObject(object) {
        return Types.address._to_address(object);
    },
    toObject: function toObject(object) {
        var debug = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        if (debug.use_default && object === undefined) {
            return _cjs.ChainConfig.address_prefix + "664KmHxSuQyDsfwo4WEJvWpzg1QKdg67S";
        }
        return Types.address._to_address(object).toString();
    },
    compare: function compare(a, b) {
        return strCmp(a.toString(), b.toString());
    }
};

var strCmp = function strCmp(a, b) {
    return a > b ? 1 : a < b ? -1 : 0;
};
var firstEl = function firstEl(el) {
    return Array.isArray(el) ? el[0] : el;
};
var sortOperation = function sortOperation(array, st_operation) {
    return array;
};
// st_operation.nosort ? array :
// st_operation.compare ? array.sort((a,b)=> st_operation.compare(firstEl(a), firstEl(b))) : // custom compare operation
// array.sort((a,b)=>
//     typeof firstEl(a) === "number" && typeof firstEl(b) === "number" ? firstEl(a) - firstEl(b) :
//     // A binary string compare does not work. Performanance is very good so HEX is used..  localeCompare is another option.
//     Buffer.isBuffer(firstEl(a)) && Buffer.isBuffer(firstEl(b)) ? strCmp(firstEl(a).toString("hex"), firstEl(b).toString("hex")) :
//     strCmp(firstEl(a).toString(), firstEl(b).toString())
// )

exports.default = Types;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/dcorejs-lib/lib/serializer/src/types.js
// module id = 51
// module chunks = 0